import { render, staticRenderFns } from "./PricePostingUsaProSelector.vue?vue&type=template&id=a9a19080&scoped=true"
import script from "./PricePostingUsaProSelector.vue?vue&type=script&lang=js"
export * from "./PricePostingUsaProSelector.vue?vue&type=script&lang=js"
import style0 from "./PricePostingUsaProSelector.vue?vue&type=style&index=0&id=a9a19080&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a19080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9a19080')) {
      api.createRecord('a9a19080', component.options)
    } else {
      api.reload('a9a19080', component.options)
    }
    module.hot.accept("./PricePostingUsaProSelector.vue?vue&type=template&id=a9a19080&scoped=true", function () {
      api.rerender('a9a19080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/TargetSelector/PricePostingUsaProSelector.vue"
export default component.exports